import { useCallback } from 'react'
import { NAVBAR_HEIGHT } from '../config/constants'

export function useScrollTo() {
  return useCallback((id: string): void => {
    const el = document.getElementById(id)
    if (!el) return
    
    const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT
    window.scrollTo({ top, behavior: 'smooth' })
  }, [])
}
